import { render, staticRenderFns } from "./ViewDialogAnnouncement.vue?vue&type=template&id=583cc2ec&scoped=true&lang=pug"
import script from "./ViewDialogAnnouncement.vue?vue&type=script&lang=js"
export * from "./ViewDialogAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ViewDialogAnnouncement.vue?vue&type=style&index=0&id=583cc2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583cc2ec",
  null
  
)

export default component.exports